<template>
  <div class="table-pagination-wrapper">
    <el-pagination
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      class="premium-pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100, 200]
    }
  },
  methods: {
    handleSizeChange (size) {
      this.$emit('update:pageSize', size)
      this.$emit('size-change', size)
    },
    handleCurrentChange (page) {
      this.$emit('update:currentPage', page)
      this.$emit('current-change', page)
    }
  }
}
</script>

<style scoped>
.table-pagination-wrapper {
  padding: 12px 16px;
  background-color: transparent;
  display: flex;
  justify-content: flex-start;
}
.premium-pagination :deep(.btn-prev),
.premium-pagination :deep(.btn-next),
.premium-pagination :deep(.el-pager li) {
  background-color: var(--bg-hover) !important;
  color: var(--text-muted) !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  margin: 0 3px !important;
}
.premium-pagination :deep(.el-pager li.active) {
  background-color: var(--primary-color) !important;
  color: #FFFFFF !important;
}
.premium-pagination :deep(.el-pagination__sizes .el-input__inner),
.premium-pagination :deep(.el-pagination__editor.el-input .el-input__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
}
</style>
